/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { useEffect, useState } from 'react';

import { Screen } from '../../core/navigation/Screen';
import { ScreenController } from '../../core/navigation/ScreenController';

interface IScreenProperties<T> {
    identifier: string;
    properties?: T;
}
const useScreenController = <T>({ identifier, properties }: IScreenProperties<T>) => {
    const oScreenController: ScreenController = ScreenController.getInstance();
    const [screen, setScreen] = useState<Screen<T>>(new Screen<T>(identifier));

    const handleStackChange = () => {};

    useEffect(() => {
        oScreenController.addStackChangeListener(handleStackChange);
        if (properties) screen.setProperties(properties);
        oScreenController.push(screen);
        setScreen(oScreenController.getScreen());
        return () => {
            oScreenController.removeStackChangeListener(handleStackChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        screen,
    };
};

export default useScreenController;
